import { render, staticRenderFns } from "./template-manage-measurements.vue?vue&type=template&id=e1c204d6&scoped=true"
import script from "./template-manage-measurements.vue?vue&type=script&lang=js"
export * from "./template-manage-measurements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c204d6",
  null
  
)

export default component.exports